import {createApplication} from '@angular/platform-browser';
import {createCustomElement} from '@angular/elements';
import {WidgetComponent} from "./widget/widget.component";
import {appConfig} from "./app/app.config";


(async () => {
  try {
    const app = await createApplication(appConfig);

    const widgetElement = createCustomElement(WidgetComponent, {
      injector: app.injector,
    });

    if (!customElements.get('chatbot-widget')) {
      customElements.define('chatbot-widget', widgetElement);
    }

  } catch (error) {
    console.error('❌ Failed to initialize widget:', error);
  }
})();

